export default __webpack_public_path__ + "static/media/add.7a96dab9.svg";